import type { QueryClient } from '@tanstack/react-query';
import type { useTRPC } from 'src/utils/trpc';

/**
 * Refresh every change-request read surface after a mutation raised or
 * touched a CR (RSP-5789): the register, the pending-only per-parent feed,
 * and the all-statuses per-parent feed the approval panel renders from.
 * Without this, a gated mutation's freshly-created CR stays invisible until
 * the panel's next poll tick.
 *
 * Call from a governed-entity mutation hook's `onSuccess` ONLY on the
 * change-request branches (`result.status !== 'applied'` for single-Id
 * mutations; `result.changeRequestIds.length > 0` for bulk) — the applied
 * branch touches no CR rows. Notifications stay OUT of hooks (FormContext
 * owns mutation UX; see packages/web/CLAUDE.md).
 */
export const invalidateChangeRequestFeeds = async (
  queryClient: QueryClient,
  trpc: ReturnType<typeof useTRPC>
): Promise<void> => {
  await queryClient.invalidateQueries({
    queryKey: trpc.frontend.changeRequest.register.queryKey(),
  });
  await queryClient.invalidateQueries({
    queryKey: trpc.frontend.changeRequest.pendingChangeRequests.queryKey(),
  });
  await queryClient.invalidateQueries({
    queryKey: trpc.frontend.changeRequest.changeRequestsByParent.queryKey(),
  });
};
